module.exports = __webpack_public_path__ + "img/red connect 4 piece.3383830f.png";